import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AtlasGridOptions } from './altas-grid-options.model';
import { TranslateService } from '@ngx-translate/core';
import { Paginated } from '../../../models/paginated';
import { GridHeaderSelectComponent } from './renderer/grid-header-select.component';
import { Observable } from 'rxjs';
import $ from 'jquery';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { LocalStorageService } from 'ngx-webstorage';
import { formatIntNumber, limitedParallelObservableExecution } from '../../../utils/utils';
import { CustomNoRowsOverlayComponent } from '@ui/components/atlas-grid/overlay/custom-no-rows-overlay.component';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons/faPlusCircle';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons/faMinusCircle';
import { UntypedFormControl } from '@angular/forms';
import { ContactService } from '@services/contact.service';

// import { faSort } from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'wsb-atlas-grid',
  templateUrl: './atlas-grid.component.html',
  styleUrls: ['./atlas-grid.component.scss'],
  standalone: false
})
export class AtlasGridComponent implements OnInit, OnChanges {
  constructor(
    private translateService: TranslateService,
    private localStorage: LocalStorageService,
    private contactService: ContactService
  ) {
    // Translation se
    if (!this.localeText) {
      this.translateService
        .get(
          Object.keys(this.translations).map(x => {
            return 'table_' + x;
          })
        )
        .subscribe((labels: object) => {
          this.localeText = {};
          Object.keys(labels).forEach(label => {
            this.localeText[label.substr(6)] = label === labels[label] ? this.translations[label.substr(6)] : labels[label];
          });
          if (this.options) {
            this.options.localeText = this.localeText;
          }
          this.localeReady = true;
        });
    } else {
      if (this.options) {
        this.options.localeText = this.localeText;
      }
      this.localeReady = true;
    }
  }

  public mask = {
    guide: true,
    showMask: true,
    // keepCharPositions : true,
    mask: '00:00'
  };

  @Input() public columnDefs: [];
  @Input() public rowData;
  @Input() public page;
  @Input() public showFilters = false;
  @Input() public checkboxDisable;
  @Input() public options: AtlasGridOptions | any;
  @Input() public components;
  @Input() public loading: boolean;
  @Input() public exportFc: UntypedFormControl;
  @Input() public exportOnlyCampaign = false;
  @Input() public isMailPage = false;
  @Input() public emailList = [];
  @Output() selectionChange = new EventEmitter();
  @Output() dataIsLoaded = new EventEmitter();
  @Output() searchEvent = new EventEmitter();
  @Output() selectionChangeCheckbox = new EventEmitter();
  @Output() selectAllCheckbox = new EventEmitter();
  @Output() exportGlobal = new EventEmitter();
  @ViewChild('agGrid') $agGrid;
  localeReady: boolean;
  localeText: null | object = null;
  // faSort                      = faSort;

  numSelected: number;
  selectAllTotal = false;
  preventSelectionChanging = false;

  customSelectedByPropertyValues = [];
  customSelectedByPropertyName = null;

  // columnFilters               = null;
  columnPreferences = null;

  export = false;
  exportText = '';
  exportButtons: any = [];

  showExport = false;
  filtersApplied = false;
  public filtersModel: any = {};

  showFiltersAdvanced = false;
  filtersAdvancedApplied = false;
  faPlus = faPlusCircle;
  faMinus = faMinusCircle;

  pagination = {
    labels: {
      startRow: null,
      endRow: null,
      rowCount: null,
      pageSize: null,
      goToPage: null,
      currentPage: null,
      totalPages: null,
      paginationPerPageOptions: [10, 25, 50, 100].map(x => ({
        label: x,
        value: x
      })),
      pages: [],
      hasPrevious: false,
      hasNext: false
    },
    functions: {
      onPageSizeChange: e => {
        this.options.api.paginationSetPageSize(e.value);
      },
      goToPage: num => {
        if (num < 1 || num > this.pagination.labels.totalPages) {
          return false;
        }
        this.options.api.paginationGoToPage(num - 1);
        return false;
      },
      goToNextPage: () => {
        if (!this.pagination.labels.hasNext) {
          return false;
        }
        this.options.api.paginationGoToNextPage();
        return false;
      },
      goToPreviousPage: () => {
        if (!this.pagination.labels.hasPrevious) {
          return false;
        }
        this.options.api.paginationGoToPreviousPage();
        return false;
      }
    }
  };

  // s/ajax/contacts/filters/get-filters
  filtersAdvancedDefaultOperations = {
    STRING: [
      {
        label: 'tables_advfilter_cond_equal',
        value: 'EQ'
      },
      {
        label: 'tables_advfilter_cond_not_equal',
        value: 'NQ'
      },
      {
        label: 'tables_advfilter_cond_start_with',
        value: 'SW'
      }
    ],
    CAMPAIGN: [
      {
        label: 'src_cond_confirmed_campaign',
        value: 'CC'
      },
      {
        label: 'src_cond_do_not_disturb_campaign',
        value: 'DC'
      },
      {
        label: 'src_cond_signed_campaign',
        value: 'SC'
      }
    ],
    EMAIL: [
      {
        label: 'tables_advfilter_cond_equal',
        value: 'EQ'
      },
      {
        label: 'tables_advfilter_cond_not_equal',
        value: 'NQ'
      },
      {
        label: 'tables_advfilter_cond_start_with',
        value: 'SW'
      }
    ],
    DATE: [
      {
        label: 'tables_advfilter_cond_equal',
        value: 'EQ'
      },
      {
        label: 'tables_advfilter_cond_greater_than_or_equal_to',
        value: 'GE'
      },
      {
        label: 'tables_advfilter_cond_greater_than',
        value: 'GT'
      },
      {
        label: 'tables_advfilter_cond_less_than_or_equal_to',
        value: 'LE'
      },
      {
        label: 'tables_advfilter_cond_less_than',
        value: 'LT'
      },
      {
        label: 'tables_advfilter_cond_not_equal',
        value: 'NQ'
      }
    ],
    DROPDOWN: [
      {
        label: 'tables_advfilter_cond_equal',
        value: 'EQ'
      },
      {
        label: 'tables_advfilter_cond_not_equal',
        value: 'NQ'
      }
    ]
  };
  filtersAdvancedDefaultOptions = {};
  public filtersAdvancedModel: any[] = [{}];

  translations = {
    // Set Filter
    selectAll: 'Select All',
    selectAllSearchResults: 'Select All Search Results',
    searchOoo: 'Search...',
    blanks: 'Blanks',
    noMatches: 'No matches.',

    // Number Filter & Text Filter
    filterOoo: 'Filter...',
    equals: 'Equals',
    notEqual: 'Not equal',

    // Number Filter
    lessThan: 'Less than',
    greaterThan: 'Greater than',
    lessThanOrEqual: 'Less than or equal',
    greaterThanOrEqual: 'Greater than or equal',
    inRange: 'In range',
    inRangeStart: 'To',
    inRangeEnd: 'From',

    // Text Filter
    contains: 'Contains',
    notContains: 'Not contains',
    startsWith: 'Starts with',
    endsWith: 'Ends with',

    // Date Filter
    dateFormatOoo: 'Yyyy-mm-dd',

    // Filter Conditions
    andCondition: 'AND',
    orCondition: 'OR',

    // Filter Buttons
    applyFilter: 'Apply',
    resetFilter: 'Reset',
    clearFilter: 'Clear',
    cancelFilter: 'Cancel',

    // Side Bar
    columns: 'Columns',
    filters: 'Filters',

    // columns tool panel
    pivotMode: 'Pivot Mode',
    groups: 'Row Groups',
    rowGroupColumnsEmptyMessage: 'Drag here to set row groups',
    values: 'Values',
    valueColumnsEmptyMessage: 'Drag here to aggregate',
    pivots: 'Column Labels',
    pivotColumnsEmptyMessage: 'Drag here to set column labels',

    // Header of the Default Group Column
    group: 'Group',

    // Other
    loadingOoo: 'Loading...',
    noRowsToShow: 'No Rows To Show',
    enabled: 'Enabled',

    // Menu
    pinColumn: 'Pin Column',
    pinLeft: 'Pin Left',
    pinRight: 'Pin Right',
    noPin: 'No Pin',
    valueAggregation: 'Value Aggregation',
    autosizeThiscolumn: 'Autosize This Column',
    autosizeAllColumns: 'Autosize All Columns',
    groupBy: 'Group by',
    ungroupBy: 'Un-Group by',
    resetColumns: 'Reset Columns',
    expandAll: 'Expand All',
    collapseAll: 'Close All',
    copy: 'Copy',
    ctrlC: 'Ctrl+C',
    copyWithHeaders: 'Copy With Headers',
    paste: 'Paste',
    ctrlV: 'Ctrl+V',
    export: 'Export',
    csvExport: 'CSV Export',
    excelExport: 'Excel Export (.xlsx)',
    excelXmlExport: 'Excel Export (.xml)',

    // Enterprise Menu Aggregation and Status Bar
    sum: 'Sum',
    min: 'Min',
    max: 'Max',
    none: 'None',
    count: 'Count',
    avg: 'Average',
    filteredRows: 'Filtered',
    selectedRows: 'Selected',
    totalRows: 'Total Rows',
    totalAndFilteredRows: 'Rows',
    page: 'Page',
    more: 'More',
    to: 'To',
    of: 'Of',
    next: 'Next',
    last: 'Last',
    first: 'First',
    previous: 'Previous',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
    pivotChart: 'Pivot Chart',
    chartRange: 'Chart Range',

    columnChart: 'Column',
    groupedColumn: 'Grouped',
    stackedColumn: 'Stacked',
    normalizedColumn: '100% Stacked',

    barChart: 'Bar',
    groupedBar: 'Grouped',
    stackedBar: 'Stacked',
    normalizedBar: '100% Stacked',

    pieChart: 'Pie',
    pie: 'Pie',
    doughnut: 'Doughnut',

    line: 'Line',

    xyChart: 'X Y (Scatter)',
    scatter: 'Scatter',
    bubble: 'Bubble',

    areaChart: 'Area',
    area: 'Area',
    stackedArea: 'Stacked',
    normalizedArea: '100% Stacked',

    histogramChart: 'Histogram',

    // Charts
    pivotChartTitle: 'Pivot Chart',
    rangeChartTitle: 'Range Chart',
    settings: 'Settings',
    data: 'Data',
    format: 'Format',
    categories: 'Categories',
    defaultCategory: '(None)',
    series: 'Series',
    xyValues: 'X Y Values',
    paired: 'Paired Mode',
    axis: 'Axis',
    navigator: 'Navigator',
    color: 'Color',
    thickness: 'Thickness',
    xType: 'X Type',
    automatic: 'Automatic',
    category: 'Category',
    number: 'Number',
    time: 'Time',
    xRotation: 'X Rotation',
    yRotation: 'Y Rotation',
    ticks: 'Ticks',
    width: 'Width',
    height: 'Height',
    length: 'Length',
    padding: 'Padding',
    spacing: 'Spacing',
    chart: 'Chart',
    title: 'Title',
    titlePlaceholder: 'Chart title - double click to edit',
    background: 'Background',
    font: 'Font',
    top: 'Top',
    right: 'Right',
    bottom: 'Bottom',
    left: 'Left',
    labels: 'Labels',
    size: 'Size',
    minSize: 'Minimum Size',
    maxSize: 'Maximum Size',
    legend: 'Legend',
    position: 'Position',
    markerSize: 'Marker Size',
    markerStroke: 'Marker Stroke',
    markerPadding: 'Marker Padding',
    itemSpacing: 'Item Spacing',
    itemPaddingX: 'Item Padding X',
    itemPaddingY: 'Item Padding Y',
    layoutHorizontalSpacing: 'Horizontal Spacing',
    layoutVerticalSpacing: 'Vertical Spacing',
    strokeWidth: 'Stroke Width',
    offset: 'Offset',
    offsets: 'Offsets',
    tooltips: 'Tooltips',
    callout: 'Callout',
    markers: 'Markers',
    shadow: 'Shadow',
    blur: 'Blur',
    xOffset: 'X Offset',
    yOffset: 'Y Offset',
    lineWidth: 'Line Width',
    normal: 'Normal',
    bold: 'Bold',
    italic: 'Italic',
    boldItalic: 'Bold Italic',
    predefined: 'Predefined',
    fillOpacity: 'Fill Opacity',
    strokeOpacity: 'Line Opacity',
    histogramBinCount: 'Bin count',
    columnGroup: 'Column',
    barGroup: 'Bar',
    pieGroup: 'Pie',
    lineGroup: 'Line',
    scatterGroup: 'X Y (Scatter)',
    areaGroup: 'Area',
    histogramGroup: 'Histogram',
    groupedColumnTooltip: 'Grouped',
    stackedColumnTooltip: 'Stacked',
    normalizedColumnTooltip: '100% Stacked',
    groupedBarTooltip: 'Grouped',
    stackedBarTooltip: 'Stacked',
    normalizedBarTooltip: '100% Stacked',
    pieTooltip: 'Pie',
    doughnutTooltip: 'Doughnut',
    lineTooltip: 'Line',
    groupedAreaTooltip: 'Area',
    stackedAreaTooltip: 'Stacked',
    normalizedAreaTooltip: '100% Stacked',
    scatterTooltip: 'Scatter',
    bubbleTooltip: 'Bubble',
    histogramTooltip: 'Histogram',
    noDataToChart: 'No data available to be charted.',
    pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.'
  };

  selectedBulkOption;

  showLoading() {
    this.loading = true;
    this.options.suppressLoadingOverlay = false;
    this.options.api.showLoadingOverlay();
  }

  hideLoading() {
    this.loading = false;
    this.checkLoading();
  }

  checkLoading() {
    if (this.loading) {
      // console.log('loadtrue');
      this.options.suppressLoadingOverlay = false;
      this.options.api.showLoadingOverlay();
    } else {
      // console.log('loadfalse');
      if (this.options.api && this.options.api.hideOverlay) {
        this.options.api.hideOverlay();
      }
      this.options.suppressLoadingOverlay = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.loading && changes.loading.currentValue !== changes.loading.previousValue) {
      if (this.options && this.options.api) {
        this.loading = changes.loading.currentValue;
        this.checkLoading();
      }
      // // show 'loading' overlay
      // gridOptions.api.showLoadingOverlay();
      //
      // // show 'no rows' overlay
      // gridOptions.api.showNoRowsOverlay();
      //
      // // clear all overlays
      // gridOptions.api.hideOverlay();
    }
  }

  commonReloadList(params?) {
    // console.log('asking for ' + params.startRow + ' to ' + params.endRow);
    // let pageNum = Math.round(params.endRow / PAGE_SIZE);

    // console.log(params,'ffff');
    // api.gridOptionsWrapper.gridOptions.reloadList();
    const that = this;
    this.loading = true;
    this.checkLoading();
    this.filtersApplied = !!Object.values(this.filtersModel).some((x: any) =>
      typeof x === 'object' ? x.value !== null && x.value !== '' : x !== null && x !== ''
    );
    this.filtersAdvancedApplied = !!Object.values(this.filtersAdvancedModel).some((x: any) => {
      return x.filter && x.operation && x.value;
    });
    this.options.loadFunction(params.startRow, params.endRow, params.sortModel).subscribe(
      (data: Paginated) => {
        // this.tableGridOptions.paginationPageSize = 50;
        that.loading = false;
        that.checkLoading.call(that);
        if (!data.total) {
          that.options.api.showNoRowsOverlay();
        }
        params.successCallback(data.toRawValue(), data.total);
        if (this.options.autoHeight) {
          that.setAutoRowsHeight(that);
        }
        this.dataIsLoaded.emit(true);
      },
      error => {
        this.dataIsLoaded.emit(true);
      }
    );
  }

  setAutoRowsHeight(that) {
    const gridOptions = this.options.api.gridOptionsWrapper.gridOptions;
    // const countOfRows = gridOptions.api.getDisplayedRowCount();
    const rowsHeights = [];
    $('.ag-center-cols-container > [role="row"]', that.$agGrid._nativeElement).each((index, element) => {
      // let maxHeight = -1;
      let maxHeight = $(element).height();
      $('> div', $(element))
        .css('height', 'auto')
        .each(function() {
          if ($(this).height() > maxHeight) {
            maxHeight = $(this).outerHeight();
          }
        });
      rowsHeights.push(maxHeight);
      // this.gridOptions.api.getRowNode(id)
    });

    let gridHeight = 0;
    let initialGridTop = 0;
    let i = 0;
    gridOptions.api.forEachNode(node => {
      if (i === 0) {
        initialGridTop = node.rowTop;
      }
      const maxHeight = rowsHeights[i];
      node.setRowHeight(maxHeight);
      node.setRowTop(gridHeight + initialGridTop);
      gridHeight += maxHeight;
      i++;
    });
    $('.ag-body-container,.ag-center-cols-clipper', that.$agGrid._nativeElement).height(gridHeight);
  }

  onGridReady(e) {
    const api = e.api;
    if (api.gridOptionsWrapper.gridOptions.getApi) {
      api.gridOptionsWrapper.gridOptions.getApi(api);
    }
    api.refreshHeader();
    api.sizeColumnsToFit();
    if (api.gridOptionsWrapper.gridOptions.source) {
      // api.paginationGoToPage((page) => {
      //   const params = {
      //     page
      //   };
      //   api.gridOptionsWrapper.gridOptions.reloadList(params);
      // });
      api.setDatasource(api.gridOptionsWrapper.gridOptions.source);
    }

    if (api.gridOptionsWrapper.gridOptions.bulkOptions || api.gridOptionsWrapper.gridOptions.enableSelect) {
      api.selectAllComponentClick = () => {
        api.gridOptionsWrapper.gridOptions.atlasGrid.selectDeselectCurrentPage();
      };
    }

    // if (api.gridOptionsWrapper.gridOptions.quickFilter) {
    //   api.setQuickFilter('new filter text');
    // }
    api.gridOptionsWrapper.gridOptions.atlasGrid.setColumnPreferences();
    api.gridOptionsWrapper.gridOptions.atlasGrid.setExport();
  }

  saveColumnPreferences() {
    const keyName = this.isMailPage ? 'mailColumnCustomization-' : 'columnCustomization-';

    this.localStorage.store(keyName + this.options.api.gridOptionsWrapper.gridOptions.columnCustomizationKey, this.columnPreferences);
    this.setColumnPreferences(true);
  }

  setExport() {
    if (!this.options.api || !this.options.api.gridOptionsWrapper || !this.options.api.gridOptionsWrapper.gridOptions.export) {
      return;
    }
    this.export = true;
    this.exportText = this.options.api.gridOptionsWrapper.gridOptions?.exportText || '';
    this.exportButtons = this.options.api.gridOptionsWrapper.gridOptions?.exportButtons || [{ label: 'common_confirm', value: true }];
  }

  setColumnPreferences(saving = false) {
    const keyName = this.isMailPage ? 'mailColumnCustomization-' : 'columnCustomization-';

    if (
      !this.options.api ||
      !this.options.api.gridOptionsWrapper ||
      !this.options.api.gridOptionsWrapper.gridOptions.columnCustomizationKey
    ) {
      // this.columnsReady = true;
      return;
    }
    let updateCols = false;
    let columnPreferencesData = this.localStorage.retrieve(
      keyName + this.options.api.gridOptionsWrapper.gridOptions.columnCustomizationKey
    );
    if (!saving) {
      if (!columnPreferencesData) {
        columnPreferencesData = [];
      }
      // Add new columns in preferences
      this.options.api.columnModel.columnDefs.map(el => {
        if (el.colPrefKey && !columnPreferencesData.find(x => x.key === el.colPrefKey)) {
          columnPreferencesData.push({
            label: el.headerNameTranslate ? el.headerNameTranslate : el.headerName,
            labelTranslate: el.headerNameTranslate ? true : false,
            key: el.colPrefKey,
            hide: el.hide ? el.hide : false
          });
        }
      });
      // Remove missing columns in preferences
      columnPreferencesData = columnPreferencesData.filter(
        el => this.options.api.columnModel.columnDefs.filter(x => el.key === x.colPrefKey).length > 0
      );
      this.columnPreferences = columnPreferencesData;
      updateCols = true; // TODO better check if any real change for performance improvement
    }
    if (saving || updateCols) {
      // https://www.ag-grid.com/javascript-grid-column-properties/  hide column property!
      const columnDefs = [];
      const columnDefsMapping = {};
      this.options.api.columnModel.columnDefs.map(el => {
        if (el.colPrefKey) {
          columnDefsMapping[el.colPrefKey] = el;
        }
      });
      this.options.api.columnModel.columnDefs.map(el => {
        if (!el.colPrefKey && el.field === '__sel') {
          columnDefs.push(el);
        }
      });
      columnPreferencesData.map(el => {
        if (columnDefsMapping[el.key]) {
          // columnDefsMapping[el.key].hide = el.hide;
          columnDefs.push(columnDefsMapping[el.key]);
        }
      });
      this.options.api.columnModel.columnDefs.map(el => {
        if (!el.colPrefKey && el.field !== '__sel') {
          columnDefs.push(el);
        }
      });
      // this.options.api.setColumnDefs(columnDefs);
      this.options.api.gridOptionsWrapper.gridOptions.api.setColumnDefs(columnDefs);
      // this.options.api.refreshHeader();

      // const fColsOrder = [];
      // console.log('columnDefs', columnDefs);
      let i = 0;
      columnDefs.map(el => {
        // fColsOrder.push(el.field);
        this.options.columnApi.moveColumn(el.field, i++);
      });
      columnPreferencesData.map(el => {
        if (columnDefsMapping[el.key]) {
          this.options.columnApi.setColumnsVisible([columnDefsMapping[el.key].field], !el.hide);
        }
      });
      this.options.api.sizeColumnsToFit();
      this.options.api.refreshHeader();
    }
    // this.columnsReady = true;
  }

  refresh() {
    // this.loading = true;
    // this.options.suppressLoadingOverlay = false;
    // this.options.api.showLoadingOverlay();
    if (this.options.api.gridOptionsWrapper.gridOptions.source) {
      this.options.api.setDatasource(this.options.api.gridOptionsWrapper.gridOptions.source);
    } else {
      this.options.api.refreshInfiniteCache();
    }
    this.setColumnPreferences();
  }

  isSelectedAll() {
    return this.selectAllTotal;
  }

  /**
   *
   * @param expanded, if true it will get complete list also if all elements selected in paginated
   */
  getSelectedList(expanded = true) {
    const that = this;
    return new Observable(observer => {
      const selectedRows = [];
      if (that.selectAllTotal) {
        if (expanded) {
          // Cycle necessary paginated
          const requests = [];
          //          const processMax  = 5000;
          const processMax = 5000;
          const numberRequests = Math.ceil(this.numSelected / processMax);

          for (let i = 0; i < numberRequests; i++) {
            const min = i * processMax;
            const max = min + processMax;
            requests.push([min, max]);
          }

          limitedParallelObservableExecution(
            requests,
            item => {
              return that.options.loadFunction(item[0], item[1]);
            },
            5
          ).subscribe(alldata => {
            alldata.map(data => {
              data.toRawValue().forEach(rowNode => {
                selectedRows.push(rowNode);
              });
            });
            observer.next(selectedRows);
            observer.complete();
          });

          // this.options.loadFunction(0, 5000).subscribe((data: Paginated) => {
          //   data.toRawValue().forEach(rowNode => {
          //     selectedRows.push(rowNode);
          //   });
          //   observer.next(selectedRows);
          //   observer.complete();
          // });
        } else {
          observer.next([]);
          observer.complete();
        }
      } else {
        if (that.options.api.getSelectedNodes()) {
          that.options.api.getSelectedNodes().forEach(rowNode => {
            selectedRows.push(rowNode.data);
          });
        }
        observer.next(selectedRows);
        observer.complete();
      }
    });
  }

  // setSelectedList(selected) {
  //
  //   this.gridApi.forEachNode(node => {
  //   for (let i=0; i<len; i++) {
  //   if(node.id === tempSelected[i]){
  //   node.setSelected(true);
  // }
  // }
  // });
  // }

  setSelectedCustomByPropertyList(selectedValues, propertyName) {
    this.deselectAll();
    this.options.api.forEachNode(node => {
      if (node.data) {
        const index = selectedValues.indexOf(node.data[propertyName]);
        if (index !== -1) {
          selectedValues.splice(index, 1);
          node.setSelected(true);
        }
      }
    });
    this.customSelectedByPropertyName = propertyName;
    this.customSelectedByPropertyValues = selectedValues;
    this.reloadNumSelected();
  }

  ngOnInit() {
    const that = this;

    /*// put this in any .js file that gets loaded before ag-grid is used
import { PropertyKeys } from "ag-grid/dist/lib/propertyKeys";
import { ColDefUtil } from "ag-grid/dist/lib/components/colDefUtil";
// fix wrong property warning
PropertyKeys.ALL_PROPERTIES.push("__ob__");
ColDefUtil.ALL_PROPERTIES.push("__ob__");*/

    this.options.suppressPropertyNamesCheck = true;

    this.components.customNoRowsOverlay = CustomNoRowsOverlayComponent;

    if (!this.options.noRowsOverlayOptions) {
      this.options.noRowsOverlayOptions = {};
    }
    // this.options.noRowsOverlayOptions = {
    //   title: 'tables_noresults_smslist',
    //   message: 'tables_noresultstext_smslist',
    //   image: '/assets/images/icons/grid/icon-start-messaging.svg',
    //   button: {
    //     label: 'hola',
    //     click: () => { alert(123); }
    //   }
    // };
    this.options.noRowsOverlayComponent = 'customNoRowsOverlay';
    this.options.noRowsOverlayComponentParams = {
      filtersApplied() {
        return that.filtersApplied;
      },
      clearAllFilters() {
        that.clearFilters();
      },
      options() {
        return that.options.noRowsOverlayOptions;
      }
      // noRowsMessageFunc() {
      //   return 'Sorry - no rows! at: ' + new Date();
      // },
    };

    // console.log(this.columnDefs, this.rowData, this.options);

    this.options.suppressLoadingOverlay = true;
    if (!this.options.rowHeight) {
      this.options.rowHeight = 58;
    }
    this.options.domLayout = 'autoHeight';

    this.options.suppressCellFocus = true;
    if (this.localeText) {
      this.options.localeText = this.localeText;
    }
    if (this.options.loadFunction) {
      // this.rowData = [];
      this.options.cacheBlockSize = this.options.paginationPageSize;
      this.options.maxBlocksInCache = 1;
      this.options.rowModelType = 'infinite';
      this.options.source = {
        getRows: this.commonReloadList.bind(this)
      };
    }

    this.options.suppressPaginationPanel = true; // custom pagination

    // Sorting
    this.options.defaultColDef = {
      sortable: true,
      unSortIcon: true,
      resizable: this.options.resizable === false ? false : true
    };
    const actionsColumn: any = this.columnDefs.find((x: any) => x.headerNameTranslate === 'common_actions');
    if (actionsColumn) {
      actionsColumn.sortable = false;
      actionsColumn.resizable = false;
      // actionsColumn.pinned = 'right';
      actionsColumn.suppressSizeToFit = true;
    }
    // https://www.ag-grid.com/javascript-grid-header-rendering/
    // https://www.ag-grid.com/javascript-grid-column-header/
    // Custom sorting functions https://www.ag-grid.com/javascript-grid-sorting/
    this.columnDefs.map((column: any) => {
      if (!column.comparator) {
        if (column.sortingRule) {
          column.comparator = (valueA, valueB, nodeA, nodeB, isInverted) => {
            let v1 = valueA;
            let v2 = valueB;
            if (column.sortingRule.type === AtlasGridOptions.sortingRule.type.NUMERIC) {
              if (column.sortingRule.value && typeof column.sortingRule.value === 'string') {
                // If sortingRule has a string value we use a different node field to sort
                v1 = Number(nodeA.data[column.sortingRule.value]);
                v2 = Number(nodeB.data[column.sortingRule.value]);
                if (isInverted) {
                  const c = v1;
                  v2 = v1;
                  v1 = c;
                }
              }

              if (v1 === v2) {
                return 0;
              } else {
                return v1 > v2 ? 1 : -1;
              }
            }
          };
        }
      }
    });

    // Bulk
    if ((this.options.bulkOptions || this.options.enableSelect) && this.columnDefs) {
      this.options.rowSelection = 'multiple';
      this.options.rowMultiSelectWithClick = true; // clicking on row (instead of only with checkbox) keeps selection on other rows

      this.options.suppressRowClickSelection = true;
      this.options.onCellClicked = e => {
        // console.log('clicked',e);
        if (!e.colDef.suppressCellFocus) {
          e.node.setSelected(!e.node.isSelected());
        }
      };

      const selectionCol: any = {
        headerName: '#',
        field: '__sel',
        width: 60,
        headerComponent: GridHeaderSelectComponent,
        checkboxSelection: true,
        sortable: false,
        resizable: false,
        suppressSizeToFit: true
        // pinned: 'left'
      };

      if (!this.checkboxDisable) {
        // @ts-ignore
        this.columnDefs.unshift(selectionCol);
      }

      this.options.onSelectionChanged = e => {
        // console.log('ok selection changed');
        if (!that.options.api.gridOptionsWrapper.gridOptions.atlasGrid.preventSelectionChanging) {
          // console.log('ok selection changed without prevent');
          that.options.api.gridOptionsWrapper.gridOptions.atlasGrid.selectAllTotal = false;
          that.options.api.selectAllComponent.selectAll = false;
          that.reloadNumSelected();
        }
      };

      this.options.onPaginationChanged = () => {
        const api = that.options.api;
        // If select all
        if (that.options.api.gridOptionsWrapper.gridOptions.atlasGrid.selectAllTotal) {
          that.options.api.selectAllComponent.selectAll = true;
          that.options.api.gridOptionsWrapper.gridOptions.atlasGrid.selectCurrentPage();
        } else {
          // else check if all checked in page
          const rowCount = api.getDisplayedRowCount();
          const lastGridIndex = rowCount - 1;
          const currentPage = api.paginationGetCurrentPage();
          const pageSize = api.paginationGetPageSize();
          const startPageIndex = currentPage * pageSize;
          let endPageIndex = (currentPage + 1) * pageSize - 1;

          if (endPageIndex > lastGridIndex) {
            endPageIndex = lastGridIndex;
          }

          // Count selected rows
          let cptSelected = 0;
          for (let i = startPageIndex; i <= endPageIndex; i++) {
            const rowNode = api.getDisplayedRowAtIndex(i);
            cptSelected += rowNode.selected ? 1 : 0;
          }

          // Check the checkbox if all the rows are selected
          const cptRows = endPageIndex + 1 - startPageIndex;
          api.selectAllComponent.selectAll = cptSelected && cptRows <= cptSelected;
        }

        // Custom selected
        api.forEachNode(node => {
          if (node.data) {
            const index = that.customSelectedByPropertyValues.indexOf(node.data[that.customSelectedByPropertyName]);
            if (index !== -1) {
              that.customSelectedByPropertyValues.splice(index, 1);
              node.setSelected(true);
            }
          }
        });

        this.updatePagination();
      };

      // this.columnDefs[0].headerCheckboxSelection = true;
      // // this.columnDefs[0].headerCheckboxSelectionFilteredOnly = true;
      // this.columnDefs[0].checkboxSelection = true;
    } else {
      this.options.onPaginationChanged = () => {
        this.updatePagination();
      };
    }

    // this.options.localeTextFunc = (key, defaultValue) => {
    //   // https://www.ag-grid.com/javascript-grid-localisation/#using-localetextfunc
    //   const gridKey = 'grid.' + key;
    //
    //   return new Observable(observer => {
    //     this.translateService.get(gridKey).subscribe(label => {
    //       observer.next('testmah' + label);
    //       observer.complete();
    //     });
    //   });
    // };

    // headerHeight: 0,

    // https://www.ag-grid.com/javascript-grid-row-styles/
    // this.options.rowClassRules = {
    //   'm-shadow-4'(params) {
    //     return params.rowIndex === 0;
    //   },
    // };

    if (!this.options.onGridReady) {
      // https://www.ag-grid.com/javascript-grid-reference-overview/
      this.options.onGridReady = this.onGridReady;
    } else if (!this.options.onGridReadyOld) {
      this.options.onGridReadyOld = this.options.onGridReady;
      this.options.onGridReady = e => {
        this.options.onGridReadyOld(e);
        this.onGridReady(e);
      };
    }

    // Header translation
    this.columnDefs.map(x => {
      if (x) {
        (x as any).suppressMovable = true; // disable column mouse drag
      }
      if (x && (x as any).headerNameTranslate) {
        this.translateService.get((x as any).headerNameTranslate).subscribe(label => {
          (x as any).headerName = label;
          if (that.options && that.options.api) {
            // that.options.api.columnModel.columnDefs[i].headerName = label;
            // that.options.api.setColumnDefs(that.options.api.columnModel.columnDefs);
            // that.options.api.getColumnDef((x as any).field).headerName = label;
            that.options.api.setColumnDefs(that.columnDefs);
            that.options.api.refreshHeader();
          }
        });
      }
    });

    // this.setColumnPreferences();

    this.options.atlasGrid = that;
  }

  onClick() {}

  selectDeselectCurrentPage() {
    const api = this.options.api;
    if (this.selectAllTotal) {
      this.deselectAll();
    } else {
      api.selectAllComponent.selectAll = !api.selectAllComponent.selectAll;
      api.gridOptionsWrapper.gridOptions.atlasGrid.selectAllTotal = false;
      this.selectCurrentPage();
      this.reloadNumSelected();
    }
  }

  selectCurrentPage() {
    const api = this.options.api;
    api.gridOptionsWrapper.gridOptions.atlasGrid.preventSelectionChanging = true;

    const rowCount = api.getDisplayedRowCount();
    const lastGridIndex = rowCount - 1;
    const currentPage = api.paginationGetCurrentPage();
    const pageSize = api.paginationGetPageSize();
    const startPageIndex = currentPage * pageSize;
    let endPageIndex = (currentPage + 1) * pageSize - 1;

    if (endPageIndex > lastGridIndex) {
      endPageIndex = lastGridIndex;
    }

    for (let i = startPageIndex; i <= endPageIndex; i++) {
      const rowNode = api.getDisplayedRowAtIndex(i);
      rowNode.setSelected(api.selectAllComponent.selectAll);
      if (this.page === 'contacts') {
        if (api.selectAllComponent.selectAll) {
          this.contactService.selectedList.add(rowNode.data.idContact);
        } else {
          this.contactService.selectedList.delete(rowNode.data.idContact);
        }
      }
    }
    setTimeout(() => {
      api.gridOptionsWrapper.gridOptions.atlasGrid.preventSelectionChanging = false;
    });
  }

  reloadNumSelected() {
    const that = this;
    let numSelected = 0;
    if (that.options && that.options.api) {
      if (that.selectAllTotal && that.options.api.paginationGetRowCount()) {
        numSelected += that.options.api.paginationGetRowCount();
      } else if (that.options.api.getSelectedRows().length) {
        if (this.page === 'contacts') {
          return (this.numSelected = this.contactService.selectedList.size);
        }
        numSelected += that.options.api.getSelectedRows().length;
      } else {
        numSelected += 0;
      }
    }
    numSelected += this.customSelectedByPropertyValues.length;
    if (numSelected !== this.numSelected) {
      this.selectionChange.emit(this.numSelected);
    }

    // this.selectionChange.emit(this.numSelected);

    this.numSelected = numSelected;
  }

  selectAll() {
    this.options.api.selectAllComponent.selectAll = true;
    this.selectCurrentPage();
    this.selectAllTotal = true;
    this.reloadNumSelected();
    // console.log(this.numSelected);
    // this.options.api.selectAll();
  }

  deselectAll() {
    this.selectAllTotal = false;
    this.options.api.selectAllComponent.selectAll = false;
    // this.options.api.deselectAll();
    if (this.options.api.getSelectedNodes()) {
      this.options.api.getSelectedNodes().forEach(rowNode => {
        rowNode.setSelected(false);
      });
    }
    if (this.page === 'contacts') {
      this.contactService.selectedList.clear();
    }
    this.reloadNumSelected();
  }

  filtersOpen() {
    this.showFilters = true;
  }

  filtersClick(event) {
    event.preventDefault();
    this.showFilters = !this.showFilters;
    if (this.showFilters) {
      this.showFiltersAdvanced = false;
    }
  }

  exportClick(value?) {
    this.exportGlobal.emit(value);
  }

  filter() {
    this.searchEvent.emit(this.options.api.getSelectedNodes());
    this.filtersAdvancedModel = [{}];
    this.refresh();
  }

  clearFilters() {
    this.filtersModel = {};
    if (this.filtersApplied) {
      this.filter();
    }
  }

  filtersAdvancedClick($event) {
    $event.preventDefault();
    this.showFiltersAdvanced = !this.showFiltersAdvanced;
    if (this.showFiltersAdvanced) {
      this.showFilters = false;
    }
  }

  filterAdvanced() {
    this.filtersModel = {};
    this.refresh();
  }

  clearFiltersAdvanced() {
    this.filtersAdvancedModel = [{}];
    if (this.filtersAdvancedApplied) {
      this.filter();
    }
  }

  dropdownClick() {
    return; //  fix later

    // Legacy fix for dropdowns
    // $('wsb-buttongroup-renderer .dropdown').on('show.bs.dropdown', () => {
    setTimeout(() => {
      if ($('wsb-buttongroup-renderer ' + '#atlas-gridgroup-m').length) {
        // $('body').append($('#atlas-gridgroup-m-' + rowIndex).detach());
        $('wsb-atlas-grid').append($('#atlas-gridgroup-m').detach());
      }
    }, 0);
    $('#atlas-gridgroup-m').css({
      position: 'absolute',
      left: $('#atlas-gridgroup').offset().left - $('wsb-atlas-grid').offset().left - $('#atlas-gridgroup-m').width() - 5,
      top: $('#atlas-gridgroup').offset().top - $('wsb-atlas-grid').offset().top + 50
    });

    // });
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.columnPreferences, event.previousIndex, event.currentIndex);
  }

  onBulkOptionSelected(option) {
    this.selectedBulkOption.onClick(option);
    this.selectedBulkOption = null;
  }

  onFilterChange(event?) {
    if (this.options.onFilterChange) {
      this.options.onFilterChange(event);
    }
  }

  onFilterModified(event?) {
    if (this.options.onFilterModified) {
      this.options.onFilterModified(event);
    }
  }

  filterAdvancedAddRow() {
    this.filtersAdvancedModel.push({});
  }

  filterAdvancedRemoveRow(index) {
    this.filtersAdvancedModel.splice(index, 1);
  }

  onFilterAdvancedChange(event, row) {
    row.operation = null;
    row.value = null;
  }

  isZeroPagesToDisplay() {
    const maxRowFound = this.options.api.paginationProxy.isLastPageFound();
    const totalPages = this.options.api.paginationProxy.getTotalPages();
    return maxRowFound && totalPages === 0;
  }

  updatePagination() {
    if (this.options.api) {
      const currentPage = this.options.api.paginationProxy.getCurrentPage();
      const pageSize = this.options.api.paginationProxy.getPageSize();
      const maxRowFound = this.options.api.paginationProxy.isLastPageFound();
      let rowCount = this.options.api.paginationProxy.isLastPageFound() ? this.options.api.paginationProxy.getMasterRowCount() : null;
      const totalPages = this.options.api.paginationProxy.getTotalPages();

      const rowCountCheck = this.options.api.paginationProxy.getRowCount();
      if (rowCountCheck > rowCount) {
        rowCount = rowCountCheck; // strange fix eg. for dynamic fields
      }

      let startRow: any;
      let endRow: any;

      if (this.isZeroPagesToDisplay()) {
        startRow = endRow = 0;
      } else {
        startRow = pageSize * currentPage + 1;
        endRow = startRow + pageSize - 1;
        if (maxRowFound && endRow > rowCount) {
          endRow = rowCount;
        }
      }

      // Pages
      const current = currentPage + 1;
      const last = totalPages;
      const delta = 1;
      const left = current - delta;
      const right = current + delta + 1;
      const range = [];
      const rangeWithDots = [];
      let l;

      for (let i = 1; i <= last; i++) {
        if (i === 1 || i === last || (i >= left && i < right)) {
          range.push(i);
        }
      }

      for (const i of range) {
        if (l) {
          if (i - l === 2) {
            rangeWithDots.push(l + 1);
          } else if (i - l !== 1) {
            rangeWithDots.push('...');
          }
        }
        rangeWithDots.push(i);
        l = i;
      }
      //

      this.pagination.labels.pages = rangeWithDots;

      this.pagination.labels.startRow = formatIntNumber(startRow);
      this.pagination.labels.rowCount = formatIntNumber(rowCount);
      this.pagination.labels.endRow = formatIntNumber(Math.min(endRow, rowCount));
      this.pagination.labels.pageSize = pageSize;
      this.pagination.labels.totalPages = totalPages;
      this.pagination.labels.currentPage = currentPage + 1;
      this.pagination.labels.hasPrevious = currentPage > 0;
      this.pagination.labels.hasNext = currentPage < totalPages - 1;
      this.pagination.labels.goToPage = '';
    }
  }
}
